import { Constants } from "../ENVIROMENT_VARIABLES";

const jobsContentParagraph = document.querySelectorAll(".vacancies-cards-wrapper .card-text");

function replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(10), "g");
    return str.trim().replace(re, "<br>");
}

jobsContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

(function () {
    const form = document.getElementById('careers_application_form');
    
    $(form).find('.loading-spinner').hide();
    $(form).find('.error-message').removeClass('active');
    $(form).find('.success-message').removeClass('active');

    form.addEventListener('submit', function (event) {
        $(form).find('.loading-spinner').hide();
        $(form).find('.error-message').removeClass('active');
        $(form).find('.success-message').removeClass('active');
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }else{
            event.preventDefault();
            const cvFileName = $(form).find('#upload_cv')[0].files[0].name;
            convertCVtoBase64($(form).find('#upload_cv')[0].files[0]).then( (cvBase64) => {
                SubmitCareersForm(form, cvBase64, cvFileName);
            });
        }
        $(form).addClass('was-validated');
    }, false)
    
})();

const convertCVtoBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.toString().replace(/^data:(.*,)?/, ''));
    reader.onerror = error => reject(error);
});



function SubmitCareersForm(careersForm, fileBase64, fileName) {
    const applicationData = JSON.stringify({
        FullName: $(careersForm).find('#applicant_name').val(),
        Email: $(careersForm).find('#applicant_email').val(),
        PhoneNumber: $(careersForm).find('#applicant_phone').val(),
        JobTitle: $(careersForm).find('#job_title').val(),
        CV: {filename: fileName, file: fileBase64}
    });
    //console.log(applicationData);

    // const careersFormData = new FormData();

    // careersFormData.append('FullName', applicationData.FullName);
    // careersFormData.append('Email', applicationData.Email);
    // careersFormData.append('PhoneNumber', applicationData.PhoneNumber);
    // careersFormData.append('JobTitle', applicationData.JobTitle);
    // careersFormData.append('CV', applicationData.CV);

    // for(var pair of careersFormData.entries()) {
    //     //console.log(pair[0], pair[1]);
    //   }


    $.ajax({
        url: Constants.BASE_URL + 'api/Careers/Apply',
        method: 'POST',
        contentType: 'application/json',
        // processData: false,
        // cache: false,
        // timeout: 600000,
        beforeSend: () => {
            $(careersForm).find('.loading-spinner').fadeIn();
            $('#careers_submit_btn').attr('disabled', true);
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        },
        data: applicationData,
        success: (response) => {
            //console.log(response);
            $(careersForm).find('.loading-spinner').fadeOut();
            $('#careers_submit_btn').attr('disabled', false);
            $(careersForm).find('.success-message').addClass('active');
            setTimeout( () => {
                $(careersForm).find('.success-message').removeClass('active');
             }, 5000);
        },error: (err) => {
            //console.log(err);
            $(careersForm).find('.loading-spinner').fadeOut();
            $('#careers_submit_btn').attr('disabled', false);
            $(careersForm).find('.error-message').addClass('active');
            setTimeout( () => {
                $(careersForm).find('.error-message').removeClass('active');
             }, 5000);
       }

   }).done(()=> {
        setTimeout( () => {
            $(careersForm).removeClass('was-validated');
            careersForm.reset();
        }, 0);
   });
}